import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || "";
export const API = `${BACKEND_URL}/api`;
export const ASSET_BASE = BACKEND_URL;

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("bc_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export function resolveAsset(url) {
  if (!url) return url;
  // PHP backend returns /uploads/... ; old Python backend returned /api/uploads/...
  if (url.startsWith("/uploads/") || url.startsWith("/api/uploads/")) {
    return `${ASSET_BASE}${url}`;
  }
  return url;
}
